import React, { useEffect, useRef, useState } from "react";
import { PUT, alert } from "../../components/CustomComponent";

const API = "v1/cmru/class-sections";

/**
 * ช่องชื่อเล่นที่แก้ได้ในตาราง: คลิก -> พิมพ์ -> Enter หรือคลิกที่อื่น = บันทึกทันที, Esc = ยกเลิก
 * Enter แล้วเลื่อนไปช่องชื่อเล่นของแถวถัดไปให้เลย จะได้ไล่กรอกทั้งห้องได้โดยไม่ต้องจับเมาส์
 * ใช้ร่วมกันทั้งแท็บรายชื่อและแท็บเช็คชื่อ (rowIndex ใช้หาช่องของแถวถัดไป)
 */
export default function NicknameCell({ sectionUid, enrollment, rowIndex, onSaved }) {
  const saved = enrollment.student?.nickname || "";
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(saved);
  const [isSaving, setIsSaving] = useState(false);
  const inputRef = useRef(null);
  // กัน blur ที่ตามมาหลัง Enter/Esc บันทึกซ้ำอีกรอบ
  const skipBlurRef = useRef(false);

  useEffect(() => {
    if (!isEditing) setValue(saved);
  }, [saved, isEditing]);

  useEffect(() => {
    if (isEditing) {
      // ช่องกรอกถูกถอดออกหลัง Enter/Esc โดยไม่มี blur ตามมา ธงจึงค้างเป็น true
      // ถ้าไม่ล้างตรงนี้ การแก้ครั้งถัดไปคลิกออกแล้วจะไม่บันทึก
      skipBlurRef.current = false;
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [isEditing]);

  const save = async (goNext) => {
    const next = value.trim();
    setIsEditing(false);

    if (next !== saved) {
      setIsSaving(true);
      // keepEmpty: ค่าว่างมีความหมาย (ลบชื่อเล่น) ปกติ PUT จะตัด key ที่เป็นค่าว่างทิ้งก่อนส่ง
      const result = await PUT(`${API}/${sectionUid}/students/${enrollment.uid}/nickname`, { nickname: next }, null, { keepEmpty: true, silent: true });
      setIsSaving(false);

      if (result?.status === true) {
        onSaved(next);
      } else {
        setValue(saved);
        alert("", "warning", "บันทึกชื่อเล่นไม่สำเร็จ", result?.message || "กรุณาลองใหม่อีกครั้ง");
        return;
      }
    }

    if (goNext) document.querySelector(`[data-nickname-row="${rowIndex + 1}"]`)?.click();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      skipBlurRef.current = true;
      save(true);
    } else if (event.key === "Escape") {
      skipBlurRef.current = true;
      setValue(saved);
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        className="cmru-nick-input"
        value={value}
        maxLength={100}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => {
          if (skipBlurRef.current) skipBlurRef.current = false;
          else save(false);
        }}
        aria-label={`ชื่อเล่นของ ${enrollment.student?.first_name || ""}`}
      />
    );
  }

  return (
    <button
      type="button"
      className={`cmru-nick-btn ${saved ? "" : "is-empty"}`}
      data-nickname-row={rowIndex}
      onClick={() => setIsEditing(true)}
      disabled={isSaving}
      title="คลิกเพื่อแก้ชื่อเล่น · Enter = บันทึกแล้วไปคนถัดไป · Esc = ยกเลิก"
    >
      {isSaving ? <span className="spinner-border spinner-border-sm" /> : saved || <><i className="fa-solid fa-plus" />เพิ่ม</>}
    </button>
  );
}
